import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { AlertTriangle, Activity } from 'lucide-react';
export function TheProblem() {
  return <SectionWrapper className="bg-brand-cream" data-id="element-102">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-103">
        <div className="text-center mb-12" data-id="element-104">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-100 text-brand-amber mb-6" data-id="element-105">
            <AlertTriangle className="w-8 h-8" data-id="element-106" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-6" data-id="element-107">
            El verdadero problema después de los 40
          </h2>
        </div>

        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 border border-gray-100" data-id="element-108">
          <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-109">
            Después de los 40, el metabolismo cambia, pero el estrés aumenta. En
            Estados Unidos, vivimos en un estado de "alerta constante". Este
            estrés eleva el cortisol, la hormona que le ordena a tu cuerpo
            retener líquido y acumular grasa en el vientre para "protegerse".
          </p>

          <div className="flex items-start gap-4 bg-red-50 p-6 rounded-xl mt-8" data-id="element-110">
            <Activity className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-111" />
            <p className="text-lg text-gray-800 leading-relaxed font-medium" data-id="element-112">
              Por eso, aunque cierres la boca o hagas horas de cardio, la
              báscula no se mueve y tu energía sigue por el suelo. Estás
              tratando de apagar un incendio forestal con un vaso de agua. Si no
              atacas la inflamación hormonal primero, ninguna dieta te dará el
              cuerpo que tuviste hace 10 años.
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}